import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core'
import {
  FormControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { Company, User } from '@core/models'
import { ProviderItem } from '@core/models/providers'
import { ProvidersService, ProviderType } from '@core/services/providers.service'
import { NgbActiveModal, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { Store } from '@ngrx/store'
import { TranslateService } from '@ngx-translate/core'
import { CompanyService, NgxToastrService, TravelUtilsService, UserService, UtilsService } from '@services'
import { UserCardModalComponent } from '@shared/component/user-card-modal/user-card-modal.component'
import { AppState } from 'app/app.reducer'
import moment from 'moment'
import { Subscription, take } from 'rxjs'
import Swal from "sweetalert2";

interface BookingPaymentSelection {
  payNow: boolean;
  card?: {
    name: string;
    token: string;
  };
}

@Component({
  selector: 'app-expenses',
  templateUrl: './expenses.component.html',
  styleUrls: ['./expenses.component.scss']
})
export class ExpensesComponent implements OnInit, OnDestroy {
  @Input() companyUuid: string
  @Input() userUuid: string
  @Input() departmentUuid: string
  @Input() expense
  @Output() sendInfo = new EventEmitter<any>()
  editing = false;
  loading = false
  subcriptions: Subscription[] = []
  form: UntypedFormGroup
  bodyTravel: any = {}
  file: File
  minDateNgStruct: any
  maxDateNgStruct: any
  departDataDate: any
  returnDataDate: any
  isInvalid: boolean = false
  userType: any;
  companyUsers: { name: string; lastname: string; uuid: string }[] = [];
  @Input() blobUrl?: any;
  @Input() fileBack?: any;
  files: File[] = [];
  filesToRemove: any[] = [];
  existingFiles: any[] = [];
  company: Company;
  user: User;
  expenseProviderOptions: ProviderItem[] = [];
  loadingExpenseProviders = false;
  filteredUsers: { name: string; lastname: string; uuid: string }[] = [];
  backendValidationErrors: Record<string, string> = {};

  constructor (
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    public translate: TranslateService,
    private ngxToastrService: NgxToastrService,
    private travelUtilsService: TravelUtilsService,
    private utilsService: UtilsService,
    private store: Store<AppState>,
    private ngbDateParser: NgbDateParserFormatter,
    private companyService: CompanyService,
    private userService: UserService,
    private modalService: NgbModal,
    private providersService: ProvidersService
  ) {}

  ngOnInit () {
    if (this.fileBack) {
      this.existingFiles = Array.isArray(this.fileBack) ? this.fileBack : [this.fileBack];
    }
    if (Array.isArray(this.files[0])) {
      this.files = this.files.reduce((acc, val) => acc.concat(val), []);
    }
    this.expense && this.expense !== null
      ? (this.editing = true)
      : (this.editing = false);
    if (this.expense) {
      const departDate = this.expense.beginDate.split('T')
      this.departDataDate = {
        year: parseInt(departDate[0].split('-')[0], 10),
        month: parseInt(departDate[0].split('-')[1], 10),
        day: parseInt(departDate[0].split('-')[2], 10)
      }

      const returnDate = this.expense.endDate.split('T')
      this.returnDataDate = {
        year: parseInt(returnDate[0].split('-')[0], 10),
        month: parseInt(returnDate[0].split('-')[1], 10),
        day: parseInt(returnDate[0].split('-')[2], 10)
      }
    }

    this.store
    .select("auth")
    .pipe(take(1))
    .subscribe((res) => {
      if (res.isAuthenticated) {
        this.userType = res.user.type;
      }
      if (this.userUuid) {
        this.userService
          .getUser(this.userUuid)
          .pipe(take(1))
          .subscribe((user: User) => {
            this.user = user;
            if (this.user?.companyUuid) {
              this.companyService.getCompany(this.user.companyUuid).subscribe(
                (company: Company) => {
                  this.company = company;
                },
                (error) => {}
              );
            }
          });
      }
    });

    this.form = this.formBuilder.group({
      file: [this.expense && this.expense !== null ? this.expense.file : null],
      type: [
        { value: this.expense && this.expense !== null ? this.expense.type : '', disabled: this.userType != "EMPLOYEE"},
        [Validators.required]
      ],
      price: [
        { value: 
          this.expense && this.expense !== null
          ? this.expense.price.toFixed(2) || this.expense.amount.toFixed(2)
          : '',
          disabled: this.expense?.payment || this.expense?.refund || this.userType != "EMPLOYEE"
        },
        [Validators.required, Validators.pattern(/^\d+([.,]\d{1,2})?$/)],
      ],
      wholesalePrice: [
        {
          value: this.expense
            ? (typeof this.expense?.wholesalePrice === 'number'
                ? this.expense.wholesalePrice.toFixed(2)
                : (this.expense?.wholesaleAmount
                    ? this.expense.wholesaleAmount.toFixed(2)
                    : (this.expense?.wholesalePrice || '')))
            : '',
          disabled: this.userType != "EMPLOYEE",
        },
        [Validators.pattern(/^\d+([.,]\d{1,2})?$/)],
      ],
      freeTaxes: [
        { value: this.expense && this.expense !== null && this.expense.freeTaxes
          ? this.expense.freeTaxes
          : false, disabled: this.userType != "EMPLOYEE"},
        [Validators.required]
      ],
      beginDate: [
        this.editing ? this.ngbDateParser.parse(
          moment(this.expense.beginDate).toString()
        ) : "",
        [Validators.required]
      ],
      endDate: [
        this.editing ? this.ngbDateParser.parse(
          moment(this.expense.endDate).toString()
        ) : "",
        [Validators.required],
      ],
      provider: [
        this.expense && this.expense !== null && this.expense.provider
          ? this.expense.provider
          : '',
      ],
      customCode: [
        this.expense && this.expense !== null && this.expense.customCode
          ? this.expense.customCode
          : ''
      ],
      costCenter: [
        this.expense && this.expense !== null && this.expense.costCenter
          ? this.expense.costCenter
          : ''
      ],
      supplierInvoice: [
        {
        value: this.expense && this.expense !== null && this.expense.supplierInvoice 
          ? this.expense.supplierInvoice
          : '',
        disabled: this.userType !== 'EMPLOYEE' 
        }
      ],
      bookType: [
        {
          value: this.expense && this.expense !== null && this.expense.bookType 
            ? this.expense.bookType
            : '',
          disabled: this.userType !== 'EMPLOYEE'
        }
      ],
      invoiced: [
        {
          value: this.expense && this.expense !== null && this.expense.invoiced
            ? this.expense.invoiced
            : 'none',
          disabled: this.userType !== 'EMPLOYEE',
        }
      ],
      comments: [
        this.expense?.comments ? this.expense.comments : ''
      ],
      adminComments: [
        this.expense?.adminComments ? this.expense.adminComments : ''
      ],
      annotationsExtras: [
        this.expense?.annotationsExtras ? this.expense.annotationsExtras : ''
      ],
    });

    this.loadExpenseProviders();
    
    if (this.editing) {
      this.form.addControl('passenger', new FormControl({ value: this.expense ? this.expense.userUuid : '', disabled: !(this.userType?.toLowerCase() === 'employee' || this.userType?.toLowerCase() === 'company') }));
    }

    if (this.form.value.beginDate) {
      this.form.patchValue({ beginDate: { day: this.form.value.beginDate.day, month: this.form.value.beginDate.month + 1, year: this.form.value.beginDate.year } })
    }
    if (this.form.value.endDate) {
      this.form.patchValue({ endDate: { day: this.form.value.endDate.day, month: this.form.value.endDate.month + 1, year: this.form.value.endDate.year } })
    }

    if(this.editing && this.utilsService.isAdmin(this.userType?.toLowerCase())){
      this.getCompanyUsers();
    }
  }

  get f () {
    return this.form.controls
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0 && this.userType === 'EMPLOYEE') {
      for (let i = 0; i < event.target.files.length; i++) {
        this.files.push(event.target.files[i]);
      }
    }
  }

  removeFile(index: number) {
    const fileToRemove = this.existingFiles[index] || this.files[index];
    if (fileToRemove.url) {
      this.filesToRemove.push(fileToRemove.url);
      this.existingFiles.splice(index, 1);
    } else {
      this.files.splice(index, 1);
    }
  }

  handleTravel (dataTravel: any) {
    this.bodyTravel = dataTravel
    this.travelUtilsService.setTravelLocalStorage(this.bodyTravel)
    this.translate.get(['project.form.saved']).subscribe(resp => {
      this.ngxToastrService.typeSuccess(resp['project.form.saved'], '')
    })
  }

  async onSubmit(): Promise<void> {
    if (!this.editing) {
      const paymentSelection =
        await this.showPaymentCardSelector();

      if (paymentSelection === null) {
        this.loading = false;
        return;
      }

      this.processBookingForm(
        paymentSelection.card
      );
    } else {
      this.processBookingForm();
    }
  }
  
  processBookingForm(selectedCard?: any) {
    const travel = this.travelUtilsService.getTravelLocalStorage()
    
    this.isInvalid = false
    this.loading = true
    const priceValue = this.form.get('price').value;
    const wholesalePriceValue = this.form.get('wholesalePrice').value;

    const body: any = {
      departmentUuid: this.departmentUuid,
      userUuid: this.userUuid,
      companyUuid: this.companyUuid,
      file: this.files.length > 0 ? this.files : [],
      filesToRemove: this.filesToRemove,
      price: priceValue?.toString().replace(',', '.'),
      type: this.form.get('type').value,
      freeTaxes: this.form.get('freeTaxes').value,
      providerUuid: this.form.get('provider').value,
      customCode: this.form.get('customCode').value,
      costCenter: this.form.get('costCenter').value,
      supplierInvoice: this.form.get('supplierInvoice').value,
      bookType: this.form.get('bookType').value,
      invoiced: this.form.get('invoiced').value || 'none',
      comments: this.form.get('comments').value,
      adminComments: this.form.get('adminComments').value,
      annotationsExtras: this.form.get('annotationsExtras').value,
      beginDate:
        this.form.get('beginDate').value.year +
        '-' +
        this.form.get('beginDate').value.month +
        '-' +
        this.form.get('beginDate').value.day,
      endDate:
        this.form.get('endDate').value.year +
        '-' +
        this.form.get('endDate').value.month +
        '-' +
        this.form.get('endDate').value.day
    }

    if (wholesalePriceValue !== '' && wholesalePriceValue !== null && wholesalePriceValue !== undefined) {
      body.wholesalePrice = wholesalePriceValue.toString().replace(',', '.');
    }

    if(this.editing){
      body["passenger"] = this.f.passenger.value;
    }

    if (travel && travel.data.title) {
      body['travelName'] = travel.data.title
    }
    if (selectedCard) {
      body["paymentCard"] = {
        name: selectedCard.name,
        token: selectedCard.token,
      };
    }
    this.sendInfo.emit(body);
  }

  closeModal () {
    this.activeModal.dismiss('Cross click')
  }

  getOutMinDate () {
    return this.utilsService.getOutDateSame(
      this.minDateNgStruct,
      this.form.controls['beginDate'].value
    )
  }

  getOutMaxDate () {
    return this.utilsService.getOutDateSame(
      this.maxDateNgStruct,
      this.form.controls['endDate'].value
    )
  }

  getCompanyUsers() {
    this.companyService.getCompanyUsers(this.companyUuid).subscribe(
      (res) => {
        this.companyUsers = res.map(user => ({
          name: user.name,
          lastname: user.lastname,
          uuid: user.uuid
        }));
        this.filteredUsers = [...this.companyUsers];
        if (this.expense) {
          this.form.patchValue({
            passenger: this.expense.userUuid
          });
        }
      },
      (err) => {
        console.error('Error fetching users:', err);
      }
    );
  }

  async showPaymentCardSelector(): Promise<
    BookingPaymentSelection | null
  > {
    const companyCards = this.normalizePaymentCards(
      this.user?.paymentCards
    );

    const personalCards = this.normalizePaymentCards(
      this.user?.personalPaymentCards
    );

    if (this.company?.bookedWithoutCard) {
      if (personalCards.length === 0) {
        return {
          payNow: false,
        };
      }

      const result = await Swal.fire({
        title: this.translate.instant(
          "payment.pay-now-title"
        ),
        text: this.translate.instant(
          "payment.pay-now-question"
        ),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.translate.instant(
          "payment.pay-now"
        ),
        cancelButtonText: this.translate.instant(
          "payment.pay-later"
        ),
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: "flexible-payment-swal",
        },
      });

      if (!result.isConfirmed) {
        return {
          payNow: false,
        };
      }

      const selectedCard = await this.openPaymentCardModal(
        [],
        personalCards
      );

      if (!selectedCard) {
        return null;
      }

      return {
        payNow: true,
        card: {
          name: selectedCard.name,
          token: selectedCard.token,
        },
      };
    }

    if (
      companyCards.length === 0 &&
      personalCards.length === 0
    ) {
      this.ngxToastrService.typeInfo(
        null,
        this.translate.instant(
          "common.no-card-user-error"
        )
      );

      return null;
    }

    const defaultToken =
      this.company?.cardRedsys?.find(
        (card) => card?.isDefault && card?.token
      )?.token || null;

    const orderedCompanyCards = defaultToken
      ? [
          ...companyCards.filter(
            (card) => card.token === defaultToken
          ),
          ...companyCards.filter(
            (card) => card.token !== defaultToken
          ),
        ]
      : companyCards;

    const selectedCard = await this.openPaymentCardModal(
      orderedCompanyCards,
      personalCards
    );

    if (!selectedCard) {
      return null;
    }

    return {
      payNow: true,
      card: {
        name: selectedCard.name,
        token: selectedCard.token,
      },
    };
  }

  private loadExpenseProviders(): void {
    this.loadingExpenseProviders = true;
    this.providersService.getProviders('expense' as ProviderType).subscribe({
      next: (items) => {
        const providers = (items || []).filter(p => !!p?.uuid && !!p?.name);

        const currentRaw =
          (this.expense?.provider ||
          this.form?.get('provider')?.value ||
          ''
          ).toString().trim();

        let selectedUuid: string | null = null;

        if (currentRaw) {
          const byUuid = providers.find(p => p.uuid === currentRaw);
          if (byUuid) {
            selectedUuid = byUuid.uuid;
          } else {
            const byName = providers.find(
              p => (p.name || '').toLowerCase() === currentRaw.toLowerCase()
            );
            if (byName) {
              selectedUuid = byName.uuid;
            }
          }
        }

        this.expenseProviderOptions = providers;

        if (selectedUuid && this.form?.get('provider')) {
          this.form.get('provider')!.setValue(selectedUuid);
        }
        this.loadingExpenseProviders = false;
    },
      error: (err) => {
        this.expenseProviderOptions = [];
        this.loadingExpenseProviders = false;
      }
    });
  }

  providerCompare = (a: any, b: any) =>
    (a ?? '').toString().trim().toLowerCase() === (b ?? '').toString().trim().toLowerCase();

  resetUsersFilter() {
    this.filteredUsers = [...this.companyUsers];
  }

  applyFilter(value: string) {
    const v = (value || '').trim().toLowerCase();
    if (!v) {
      this.filteredUsers = [...this.companyUsers];
      return;
    }

    this.filteredUsers = this.companyUsers.filter(u =>
      (`${u.name} ${u.lastname}`.toLowerCase().includes(v))
    );
  }

  applyBackendValidationErrors(validationErrors: any[]): void {
    this.backendValidationErrors = {};

    validationErrors.forEach((err) => {
      const backendPath = err.field;

      this.backendValidationErrors[backendPath] = err.type || 'invalid';

      const controlPath = this.mapBackendPathToAngularPath(backendPath);
      const control = this.form.get(controlPath);

      if (control) {
        control.setErrors({
          ...(control.errors || {}),
          backend: err.type || 'invalid',
        });
        control.markAsTouched();
        control.markAsDirty();
      }
    });

    this.isInvalid = true;
  }

  hasBackendError(path: string): boolean {
    return !!this.backendValidationErrors[path];
  }

  getBackendError(path: string): string {
    return this.backendValidationErrors[path] || '';
  }

  private mapBackendPathToAngularPath(path: string): string {
    const map: Record<string, string> = {
      departmentUuid: 'departmentUuid',
      companyUuid: 'companyUuid',
      userUuid: 'passenger',

      type: 'type',
      price: 'price',
      amount: 'price',
      wholesalePrice: 'wholesalePrice',
      wholesaleAmount: 'wholesalePrice',

      beginDate: 'beginDate',
      endDate: 'endDate',

      freeTaxes: 'freeTaxes',
      providerUuid: 'provider',
      provider: 'provider',

      customCode: 'customCode',
      costCenter: 'costCenter',
      supplierInvoice: 'supplierInvoice',
      bookType: 'bookType',
      invoiced: 'invoiced',
      paymentCard: 'paymentCard',
      file: 'file',
    };

    return map[path] || path;
  }

  private normalizePaymentCards(cards: any): any[] {
    const normalizedCards = Array.isArray(cards)
      ? cards
      : cards
        ? [cards]
        : [];

    return normalizedCards.filter(
      (card) =>
        card?.token &&
        typeof card?.name === "string" &&
        card.name.trim() !== ""
    );
  }

  private openPaymentCardModal(
    companyCards: any[],
    personalCards: any[]
  ): Promise<any | null> {
    return new Promise((resolve) => {
      let resolved = false;

      const modalRef = this.modalService.open(
        UserCardModalComponent,
        {
          windowClass: "custom-modal-user-card",
          centered: true,
          backdrop: "static",
          keyboard: false,
        }
      );

      modalRef.componentInstance.company = this.company;
      modalRef.componentInstance.bookCards = companyCards;
      modalRef.componentInstance.bookPersonalCards =
        personalCards;
      modalRef.componentInstance.fromBookSelect = true;

      modalRef.componentInstance.cardSelected
        .pipe(take(1))
        .subscribe((selectedCard) => {
          resolved = true;
          resolve(selectedCard);
        });

      modalRef.result
        .then(() => {
          if (!resolved) {
            resolve(null);
          }
        })
        .catch(() => {
          if (!resolved) {
            resolve(null);
          }
        });
    });
  }

  ngOnDestroy () {
    this.subcriptions.forEach(s => s.unsubscribe())
  }
}
